import { declareVrunComponent } from '/vodalys/vvuejs/declareVrunComponent.mjs'

declareVrunComponent('moodDisplay.vrun.component', () => import('./MoodDisplay.vue'))
